import type { QueryClient } from '@tanstack/react-query';

const automationFailuresQueryRoot = 'getAutomationFailures';
const automationFailureMetricsQueryRoot = 'getAutomationFailureMetrics';
const automationFailureQueryRoot = 'getAutomationFailure';

export const invalidateAutomationFailureQueries = (queryClient: QueryClient, reference?: string) =>
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) =>
      queryKey[0] === automationFailuresQueryRoot ||
      queryKey[0] === automationFailureMetricsQueryRoot ||
      (reference !== undefined &&
        queryKey[0] === automationFailureQueryRoot &&
        queryKey[1] === reference),
  });
